import { render, staticRenderFns } from "./notification-title.vue?vue&type=template&id=7a826a04&"
import script from "./notification-title.vue?vue&type=script&lang=js&"
export * from "./notification-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports